"use strict";

exports.__esModule = true;
exports.MTCDataTableElement = void 0;
exports.MTCDataTableElementClosure = MTCDataTableElementClosure;
var _react = _interopRequireWildcard(require("react"));
var _common = require("../common");
var _DataTable = require("../DataTable");
var _DataItemPopover = require("../common/DataItemPopover/DataItemPopover");
var _useFeature = _interopRequireDefault(require("../../FeatureFlags/Hooks/useFeature"));
var _featureFlags = require("../../../featureFlags");
var _Device = require("../../Device");
var _constants = require("../../constants");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function MTCDataTableElementClosure(_temp) {
  var _ref = _temp === void 0 ? {} : _temp,
    _ref$dataSource = _ref.dataSource,
    dataSource = _ref$dataSource === void 0 ? "MTC" : _ref$dataSource;
  return function MTCDataTableElement(props) {
    var device = (0, _react.useContext)(_Device.DeviceContext);
    var children = props.children,
      dataItemName = props.dataItemName,
      dataRange = props.dataRange,
      pageSizes = props.pageSizes,
      _props$configuration = props.configuration,
      configuration = _props$configuration === void 0 ? {} : _props$configuration,
      fetchDataOnlyOnSelection = props.fetchDataOnlyOnSelection,
      updateLayout = props.updateLayout,
      path = props.path;
    var editFlagEnabled = (0, _useFeature["default"])(_featureFlags.ENABLE_DATA_ITEM_EDIT, true);
    var saveFlagEnabled = (0, _useFeature["default"])(_featureFlags.ENABLE_DATA_ITEM_SAVE, true);
    var _useState = (0, _react.useState)(typeof dataItemName == "string" ? [{
        dataItemName: dataItemName
      }] : dataItemName),
      dataItemNamesValue = _useState[0],
      setDataItemNamesValue = _useState[1];
    var EditDataItemButton = function EditDataItemButton(props) {
      var onSubmit = function onSubmit(values) {
        if (saveFlagEnabled) {
          updateLayout(path, "dataItemName", values);
        }
        setDataItemNamesValue(values);
        props.reload();
      };
      return /*#__PURE__*/_react["default"].createElement(_DataItemPopover.DataItemPopover, {
        dataItems: dataItemNamesValue,
        onSubmit: onSubmit,
        showButton: true,
        device: device,
        isMultiSelector: true,
        colorSelector: false,
        ignoredCategories: dataSource === "metricMTC" ? [_constants.CATEGORY_EVENT] : []
      });
    };
    return /*#__PURE__*/_react["default"].createElement(_DataTable.DataTableElement, _extends({
      pageSizes: pageSizes || [25, 50, 100, 250],
      defaultPageSize: configuration.defaultPageSize,
      dataRange: dataRange,
      fetchDataOnlyOnSelection: fetchDataOnlyOnSelection,
      dataSource: dataSource,
      dataItemNames: dataItemNamesValue,
      configuration: Object.assign({
        overFetchAll: true,
        enablePagination: true,
        editButtonComponent: editFlagEnabled ? EditDataItemButton : undefined
      }, configuration, {
        // DataTable doesn't use columns. Type hijacking! As it is affecting others. Refactor required!!!
        columns: []
      })
    }, (0, _common.getWidgetPositionProps)(props), (0, _common.getWidgetInteractionProps)(props)), children);
  };
}
var MTCDataTableElement = exports.MTCDataTableElement = MTCDataTableElementClosure();